import { render } from "./validateOtp.vue?vue&type=template&id=09060e34&scoped=true"
import script from "./validateOtp.vue?vue&type=script&lang=js"
export * from "./validateOtp.vue?vue&type=script&lang=js"

import "./validateOtp.vue?vue&type=style&index=0&id=09060e34&scoped=true&lang=css"

import exportComponent from "C:\\BestPhone\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09060e34"]])

export default __exports__